import { Icon } from '@iconify/react';
import React, { useEffect, useState, useRef } from 'react'; // added useRef
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import Swal from '../../utils/darkSwal';
import { saveAuthData } from '../../utils/authStorage';
import BASE_URL from '../../utils/api';
import { useNavigate, Link } from 'react-router-dom';

export default function LoginPage() {
  pageTitle('Login');

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  // Ref to target the "Login with us" heading
  const titleRef = useRef(null); // NEW

  useEffect(() => {
    // Smoothly scroll the heading into view on mount
    //titleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); // NEW

    // If a fixed header overlaps the title, use this pattern instead:
    const el = titleRef.current;
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 140; // adjust 80 to header height
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, []);

  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please enter both email and password.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    // Show loading alert
    Swal.fire({
      title: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(`${BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        if (data.user.status === "active") {
          // Save user data & token to localStorage
          const expiryTime = new Date().getTime() + 2 * 60 * 60 * 1000; // 2 hours in ms

          saveAuthData(data.user, data.token);

          Swal.fire({
            icon: 'success',
            title: 'Login Successful',
            text: data.message,
            confirmButtonColor: '#1344af',
          }).then(() => {
            navigate('/');
            window.location.reload();
          });

        } else {
          Swal.fire({
            icon: 'error',
            title: 'Inactive Account',
            text: 'Your account is not active.',
            confirmButtonColor: '#1344af',
          });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Login Failed',
          text: data.message || 'Invalid credentials.',
          confirmButtonColor: '#1344af',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Failed to connect to the server.',
        confirmButtonColor: '#1344af',
      });
    }
  };

  return (
    <>
      <PageHeading
        title="Login"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Login"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row justify-content-center">
          <Div className="col-lg-6">
            {/* Login title */}
            <h3 ref={titleRef} className="text-center cs-primary_color">Login with us</h3> {/* ref added */}
            <Spacing lg="30" md="20" />

            <form action="#" className="row">
              <Div className="col-sm-12">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  className="cs-form_field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Spacing lg="20" md="20" />
              </Div>

              <Div className="col-sm-12">
                <label className="cs-primary_color">Password*</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="cs-form_field"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Icon icon={showPassword ? 'mdi:eye-off' : 'mdi:eye'} />
                  </span>
                </div>
                <Spacing lg="30" md="20" />
              </Div>

              {/* Centered Button */}
              <Div className="col-sm-12 d-flex justify-content-center">
                <button
                  type="button"
                  className="cs-btn cs-style1"
                  onClick={handleLogin}
                >
                  <span>Login</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>

            <Div className="col-sm-12 text-center mt-3">
              <p className="cs-primary_color">
                Don't have an account?{' '}
                <Link to="/register" style={{ color: '#1344af' }}>
                  Register here
                </Link>
              </p>
            </Div>

            <Div className="col-sm-12 text-center mt-2">
              <p className="cs-primary_color">
                Forgot your password?{' '}
                <Link to="/reset-password" style={{ color: '#1344af' }}>
                  Reset it here
                </Link>
              </p>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="40" />
    </>
  );
}
